import { SP } from "./namespace";
SP.PREFS_KEY = "wlkSpellPreviews";

SP.isEnabled = function() {
  try {
    const v = localStorage.getItem(SP.PREFS_KEY);
    if (v === "0") return false;
    if (v === "1") return true;
  } catch (e) { /* ignore */ }
  return false;
};

SP.setEnabled = function(on) {
  try { localStorage.setItem(SP.PREFS_KEY, on ? "1" : "0"); } catch (e) { /* ignore */ }
  for (const id of ["spellPreviewEnabled", "spellbookPreviewEnabled"]) {
    const cb = document.getElementById(id) as HTMLInputElement | null;
    if (cb) cb.checked = !!on;
  }
  if (!on) SP.Tip.hide();
};

SP.wireToggle = function() {
  const cb = document.getElementById("spellPreviewEnabled") as HTMLInputElement | null;
  if (!cb || cb.dataset.wired) return;
  cb.dataset.wired = "1";
  cb.checked = SP.isEnabled();
  cb.addEventListener("change", () => {
    SP.setEnabled(cb.checked);
    if (!cb.checked) SP.Tip.hide();
  });
};

SP.wireSpellbookToolbar = function() {
  const preview = document.getElementById("spellbookPreviewEnabled") as HTMLInputElement | null;
  if (preview && !preview.dataset.wired) {
    preview.dataset.wired = "1";
    preview.checked = SP.isEnabled();
    preview.addEventListener("change", () => {
      SP.setEnabled(preview.checked);
      if (!preview.checked) SP.Tip.hide();
    });
  }
};
